import React, { memo } from 'react';

import style from './style.module.css';

const GridCheckboxComponent = props => (
  <span className={style.host}>
    <input {...props} type="checkbox" />
  </span>
);

/**
 * Checkbox centered inside an AG-Grid selection cell. Props are passed to the input.
 */
export const GridCheckbox = memo(GridCheckboxComponent);
